import { render, staticRenderFns } from "./JadwalSholat.vue?vue&type=template&id=227d066a&scoped=true"
import script from "./JadwalSholat.vue?vue&type=script&lang=js"
export * from "./JadwalSholat.vue?vue&type=script&lang=js"
import style0 from "./JadwalSholat.vue?vue&type=style&index=0&id=227d066a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "227d066a",
  null
  
)

export default component.exports